var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRemove = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "15px",
    viewBox: "0 0 12 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "13199FCD-6C40-4E46-A685-BEA6CB3BA8DF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mockup6",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Triggers",
    transform: "translate(-1105.000000, -295.000000)",
    fill: "#9B9B9B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(576.000000, 282.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(529.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "baseline-delete_forever-24px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.833333333,13.3333333 C0.833333333,14.25 1.58333333,15 2.5,15 L9.16666667,15 C10.0833333,15 10.8333333,14.25 10.8333333,13.3333333 L10.8333333,3.33333333 L0.833333333,3.33333333 L0.833333333,13.3333333 Z M2.88333333,7.4 L4.05833333,6.225 L5.83333333,7.99166667 L7.6,6.225 L8.775,7.4 L7.00833333,9.16666667 L8.775,10.9333333 L7.6,12.1083333 L5.83333333,10.3416667 L4.06666667,12.1083333 L2.89166667,10.9333333 L4.65833333,9.16666667 L2.88333333,7.4 Z M8.75,0.833333333 L7.91666667,0 L3.75,0 L2.91666667,0.833333333 L0,0.833333333 L0,2.5 L11.6666667,2.5 L11.6666667,0.833333333 L8.75,0.833333333 Z",
    id: "Shape"
  })))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRemove);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/remove.cd7407ed207321268f20a872d86658eb.svg";